__turbopack_context__.v({
  "btn": "styles-module__BSTmRa__btn",
  "container": "styles-module__BSTmRa__container",
});
